import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getInsuranceCompany from '../../services/dossier/get/getInsuranceCompany'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchInsuranceCompanyCombo () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const insuranceCompanyCombo = yield call(getInsuranceCompany, auth.token)
    yield put(fetchCombosSuccess({ insuranceCompanyCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchInsuranceCompanyCombo () {
  yield takeLatest(combosActionTypes.FETCH_INSURANCE_COMPANY_COMBO, fetchInsuranceCompanyCombo)
}
